export const FIREBASE_ERRORS = {
  'auth/invalid-email': 'E-mail inválido, verifique se está correto.',
  'auth/weak-password': 'Senha muito fraca, por favor use ao menos 6 caracteres.',
  'auth/email-already-in-use': 'E-mail já está em uso, por favor, use outro e-mail',
};
